export default __webpack_public_path__ + "static/media/volume-max.8829fadf.svg";